export default {
  table: {
    total: "共计",
    dataCount: "条数据",
    emptyText: "暂无数据",
    loadingText: "拼命加载中",
    columns: {
      index: "序号",
      name: "名称",
      canvasName: "画布名称",
      createDate: "创建日期",
      creator: "创建人",
      updateTime: "更新时间",
      actions: "操作",
    },
    actions: {
      view: "查看",
    },
  },
};
